const DatePicker = {
  mounted(this: any) {
    this.el.addEventListener("showPicker", () => {
      this.el.showPicker();
    });
  },
};

export default DatePicker;
